import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import { useCallback } from "react"
import { dealerAppRoute } from "../../common/routes"

export const useRoutePrefix = () => {
	const { dealershipId, locale } = useDealerContext()

	return useCallback((route: string) => `${dealerAppRoute.url(dealershipId, locale)}${route}`, [dealershipId, locale])
}
